<template>
	<div class="water" :class="{ nocursor: !selected, disabled: scrollingTop }">

		<div class="canvas" />

		<div class="title" :class="{ blur }">
			<img src="@/assets/title.png">
			<div class="subtitle short" v-if="selected">Вам понравится!</div>
			<div class="subtitle" v-else>Выберите вкус блюда, который вам хочется попробовать</div>
		</div>

		<div class="content" :class="{visible: selected}">

			<div class="center" v-if="selected">
				<img class="dish" :src="recipeImage" :class="selected">
				<div class="recipe">
					<div class="top" v-html="recipeTop"></div>
					<div class="devider" />
					<div class="bottom" v-html="recipeBottom"></div>
					<a :href="recipe.url" target="_blank" @click="openRecipe">Посмотреть рецепт</a>
				</div>
			</div>

			<div class="controls" v-if="selected">
				<!-- <div class="shares-wrap" @mouseover="shares = true" @mouseout="shares = false">
					<img class="icon heart" src="@/assets/heart.png">
					<div class="text" v-if="!shares">
						Поделиться рецептом
					</div>
					
				</div> -->
				<SharesResult :type="selected" :num="selectedInd" />
				<div class="control" @click="restart">
					<img class="icon restart" src="@/assets/restart.png">
					Попробовать еще раз
				</div>
			</div>

		</div>


		<div class="map" :class="{ blur }" v-if="!selected">
			<div class="names">
				<div class="name">Сладкий</div>
				<div class="name">Кислый</div>
				<div class="name">Соленый</div>
				<div class="name">Горький</div>
			</div>
			<img class="line" src="@/assets/line.svg">
		</div>

		<div class="map-mobile" :class="{visible: !anal}" v-if="!selected">
			<div class="line">
				<div class="l1" />
				<div class="l2" />
			</div>
			<div class="names">
				<div class="row">
					<div class="name">Соленый</div>
					<div class="name">Горький</div>
				</div>
				<div class="row two">
					<div class="name">Кислый</div>
					<div class="name">Сладкий</div>
				</div>
			</div>
		</div>

		<div class="anal" :class="{visible: anal}">Анализируем ваши предпочтения</div>


	</div>
</template>


<script>
import Events from '@/events'
import Canvas from '@/canvas'
import Recipes from '@/data'
import SharesResult from '@/components/SharesResult'
import typograf from 'typograf'

const Typograf = new typograf({locale: ['ru', 'en-US']})

export default {
	name: 'Water',
	components: {
		SharesResult,
	},
	data() {
		return {
			loading: false,
			selected: null,
			selectedInd: 0,
			shares: true,
			anal: false,
			scrollingTop: false,
			blur: false,
		}
	},
	computed: {
		recipe() {
			if (!this.selected) return
			return this.recipes[this.selectedInd]
		},
		recipes() {
			if (!this.selected) return
			return Recipes[this.selected]
		},
		recipeTop() {
			if (!this.selected) return
			return Typograf.execute(this.recipe.top)
		},
		recipeBottom() {
			if (!this.selected) return
			return Typograf.execute(this.recipe.bottom)
		},
		recipeImage() {
			if (!this.selected) return
			return require(`@/assets/${this.selected}/${this.recipe.img}`)
		},
	},
	async mounted() {
		let el = this.$el.querySelector('.canvas')
		this.canvas = await Canvas.init(el, e => this.anal = true, e => this.select(e), this.$mobile)

		Events.$on('water-start', () => this.blur = true)
		Events.$on('water-end', () => this.blur = false)
	},
	methods: {
		select(type) {

			this.anal = false
			const TYPES = {
				0: 'cherry',
				1: 'lemon',
				2: 'lime',
				3: 'apple',
			}
			this.selected = TYPES[type]
			this.selectRecipe()
		},
		selectRecipe() {
			this.selectedInd = Math.floor(Math.random() * this.recipes.length)
			if (window.gtag) gtag('event', `recipe ${this.selected} ${this.selectedInd}`)
		},
		restart() {
			if (this.$mobile) this.scrollTop()
			this.selected = null
			this.selectedInd = 0
			this.canvas.disabled = false
			if (window.gtag) gtag('event', `recipe restart`)
		},
		scrollTop() {
			this.scrollingTop = true
			const top = document.documentElement.scrollTop || document.body.scrollTop
			const cur = window.innerHeight
			if (top > cur) {
				window.requestAnimationFrame(this.scrollTop)
				window.scrollTo(0, top - top / 50)
			} else {
				this.scrollingTop = false
			}
		},
		openRecipe() {
			if (window.gtag) gtag('event', `recipe link ${this.selected} ${this.selectedInd}`)
		},
	},
}
</script>


<style lang="less" scoped>
@import "../assets/app.less";

.water {
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	cursor: default;

	&.nocursor {
		cursor: pointer;
	}

	&.nocursor:active {
		cursor: none;
	}

	&.disabled {
		pointer-events: none;
	}
	
}

.canvas, .content {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
}

.blur {
	transition: all 500ms ease;
	filter: blur(15px);
}

.title {
	position: absolute;
	left: 50%;
	top: 1vh;
	transform: translateX(-46%);
	user-select: none;
	pointer-events: none;

	img {
		// width: 90%;
		max-width: 620px;
		width: 100vh;
	}

	.subtitle {
		width: 100%;
		position: absolute;
		left: 50%;
		bottom: 10%;
		transform: translateX(-55%);
		text-align: center;
		font-size: 20px;
		line-height: 22px;
		font-weight: 400;
	}

	.subtitle.short {
		transform: translateX(-52%);
		bottom: 23%;
	}
}

.map {
	position: absolute;
	width: 80%;
	left: 10%;
	bottom: 10%;
	user-select: none;
	pointer-events: none;

	.names {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.name {
		font-size: 20px;
		text-transform: uppercase;
		font-weight: 400;
		color: @gold;
	}

	.line {
		width: 94%;
		margin: 0 auto;
		margin-top: 10px;
		display: block;
	}
}

.map-mobile {
	display: none;
}

.content {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	opacity: 0;
	pointer-events: none;
	transition: opacity 500ms ease;

	&.visible {
		opacity: 1;
		pointer-events: all;
	}

}

.center {
	display: flex;
	align-items: center;
	margin-top: 200px;
	margin-left: -100px;
	z-index: 5;

	.dish {
		display: block;
		height: 60vh;
	}

	.recipe {
		width: 100%;
		max-width: 280px;
	}

	.top {
		font-size: 22px;
		color: @gold;
		line-height: 28px;
	}

	.devider {
		width: 70px;
		height: 2px;
		background: @gold;
		margin: 20px 0;
	}

	a {
		display: block;
		margin-top: 50px;
		color: @gold;
		padding: 20px 0;
	}
}

.controls {
	width: 100%;
	max-width: 440px;
	margin-bottom: 50px;
	display: flex;
	flex-shrink: 0;
	justify-content: space-between;
	font-size: 14px;
	color: @gold;

	.control {
		display: flex;
		align-items: center;
		cursor: pointer;
		padding: 10px;
		transition: all 300ms ease;
	}

	.control:hover {
		transform: scale(1.05);
	}

	.icon {
		margin-right: 5px;
		flex-shrink: 0;
	}

	.heart {
		width: 16px;
	}

	.restart {
		width: 22px;
	}

	.shares-wrap {
		background: green;
		display: flex;
	}
}

.anal {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	font-size: 26px;
	color: @gold;
	text-transform: uppercase;
	opacity: 0;
	pointer-events: none;
	transition: opacity 500ms ease;

	&.visible {
		opacity: 1;
	}
}


@media only screen and (max-width: 1000px) {


.water {
	width: 100vw;
	height: fit-content;
	overflow: auto;
	cursor: default;

	&.disabled {
		pointer-events: none;
	}
}

.content {
	height: fit-content;
	position: relative;
}

.map {
	display: none;
}

.title {
	width: 90%;
	position: absolute;
	left: 0%;
	top: 20px;
	transform: translateX(0%);
	padding: 0 5%;

	img {
		max-width: 70%;
		margin: 0 15%;
		// width: 90%;
	}

	.subtitle {
		width: 100%;
		position: relative;
		left: 0%;
		bottom: 0%;
		transform: translateX(0%) translateY(-5px);
		text-align: center;
		font-size: 16px;
		line-height: 18px;
		font-weight: 400;
	}

	.subtitle.short {
		transform: translateX(0%);
		bottom: 0%;
	}
}

.canvas {
	width: 100vw;
	min-height: 100vh;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-image: url('../assets/water.png');
	background-size: 200vw;
}


.map-mobile {
	display: block;
	position: absolute;
	width: 90vw;
	height: 90vw;
	left: 50%;
	top: 50%;
	transform: translateX(-50%) translateY(-50%);
	pointer-events: none;
	opacity: 0;
	transition: opacity 300ms ease;

	&.visible {
		opacity: 1;
	}

	.line {
		width: 100%;
		height: 100%;
		position: absolute;

		.l1 {
			width: 100%;
			height: 1px;
			background: @gold;
			position: absolute;
			top: 50%;
		}

		.l2 {
			width: 1px;
			height: 100%;
			background: @gold;
			position: absolute;
			left: 50%;
		}
	}

	.names {
		width: 100%;
		height: 100%;
		position: absolute;

		.row {
			width: 100%;
			height: 50%;
			display: flex;
		}

		.row.two {
			align-items: flex-end;
		}

		.name {
			width: 50%;
			// position: absolute;
			color: @gold;
			text-align: center;
		}

	
	}

}

.center {
	margin: 0;
	margin-top: 150px;
	display: block;
	background: url('../assets/water.png');
	background-size: cover;

	.dish {
		width: 90%;
		height: auto;
		margin: 0 auto;
	}

	.recipe {
		width: 90%;
		padding: 5%;
	}

	.top {
		font-size: 18px;
		line-height: 22px;
	}
	
	.bottom {
		font-size: 16px;
		font-weight: 400;
	}

	a {
		margin-top: 10px;
	}

}

.controls {
	width: 96%;
	background: url('../assets/water.png');
	background-size: 300vw;
	margin: 0;
	padding: 0 2%;
	padding-bottom: 50px;
}

.anal {
	text-align: center;
	font-size: 20px;
}




}




</style>